module.exports = __webpack_public_path__ + "img/DE00319.08f1ae43.svg";